import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgIf } from '@angular/common';
import { NgFor } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'formly-field-stepper-v',
  template: `
    <mat-vertical-stepper [selectedIndex]="currentIndex" #stepper >
      <mat-step *ngFor="let step of field.fieldGroup; let index = index; let last = last">
        <ng-template matStepLabel>{{ step.props.label }}</ng-template>
        <formly-field [field]="step"></formly-field>

        <div class="flex justify-between">

          <button *ngIf="index!=0" mat-flat-button matStepperPrevious class="px-4 mr-2" [color]="'primary'" type="button" [disabled]="model.is_new">
            Precedente
          </button>

          <button *ngIf="index!=0" class="items-center px-4 mr-2" mat-flat-button [color]="'primary'" type="button" (click)="field.props.salva(index)" [disabled]="model.is_new">
            Salva
          </button>

          <button matStepperNext *ngIf="!last" class="items-center px-4 mr-2" mat-flat-button [color]="'primary'" type="button" [disabled]="!isValid(step)">
            Successivo
          </button>

          <button *ngIf="last" mat-flat-button  class="items-center px-4 mr-2" [color]="'primary'" [disabled]="!form.valid" (click)="field.props.riepilogo(index)" type="button">
            Vai al riepilogo
        </button>

        </div>

      </mat-step>
    </mat-vertical-stepper>
  `,
  standalone:true,
  imports:[MatStepperModule,NgFor, NgIf, MatButtonModule,ReactiveFormsModule,FormlyMaterialModule,MatOptionModule,FormlyModule,MatSelectModule,MatInputModule]
})
export class FormlyFieldStepperV extends FieldType  implements OnInit, AfterViewInit {

    disabled: boolean;
    currentIndex: number;
    @ViewChild('stepper', {static: true}) stepper: MatStepper;



    ngOnInit(): void {
        this.disabled=this.props.disabled;
        this.currentIndex=this.props.currentIndex;
    }

    ngAfterViewInit(): void {
        this.stepper.selectedIndexChange.subscribe(
            (index)=>this.field.props.salva(index)
        )
    }



  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
        return field.formControl.valid;
    }
    return field.fieldGroup ? field.fieldGroup.every((f) => f.hide || this.isValid(f)) : true;
  }

}
